import { render, staticRenderFns } from "./nxdbqcs.vue?vue&type=template&id=1194073a&scoped=true"
import script from "./nxdbqcs.vue?vue&type=script&lang=js"
export * from "./nxdbqcs.vue?vue&type=script&lang=js"
import style0 from "./nxdbqcs.vue?vue&type=style&index=0&id=1194073a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1194073a",
  null
  
)

export default component.exports